import React from 'react'
import { Form, Switch, Space, Typography, Card } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../../lib/utils'
import GoogleAddress from '../../../../reusable-components/GoogleAddress'
import SectionWithBorder from './SectionWithBorder'

const { Text } = Typography

const AddressDetailsForm = ({ form, token, isDependant, dependantSameAddress, setDependantSameAddress }) => {
  if (isDependant && dependantSameAddress) {
    return (
      <SectionWithBorder title='Address Details' token={token} icon={faMapMarkerAlt}>
        <Card
          size='small'
          style={{
            borderRadius: '12px',
            border: `2px solid ${hexToRGBA(token.colorSuccess, 0.15)}`,
            backgroundColor: hexToRGBA(token.colorSuccess, 0.04),
            textAlign: 'center'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Space direction='vertical' size={16}>
            <Text strong style={{ fontSize: '15px', color: token.colorSuccess }}>
              Using Main Member's Address
            </Text>
            <Space size={16} align='center'>
              <Text>Same as Main Member?</Text>
              <Switch
                checked={dependantSameAddress}
                checkedChildren='Yes'
                unCheckedChildren='No'
                size='default'
                onChange={(boolean) => {
                  setDependantSameAddress(boolean)
                }}
              />
            </Space>
            <Text type='secondary' style={{ fontSize: '13px' }}>
              The dependant will use the same residential address as the main member
            </Text>
          </Space>
        </Card>
      </SectionWithBorder>
    )
  }

  return (
    <SectionWithBorder title='Address Details' token={token} icon={faMapMarkerAlt}>
      <Space direction='vertical' size={24} style={{ width: '100%' }}>
        {/* Dependant Switch */}
        {isDependant && (
          <Card
            size='small'
            style={{
              borderRadius: '12px',
              border: `2px solid ${hexToRGBA(token.colorInfo, 0.15)}`,
              backgroundColor: hexToRGBA(token.colorInfo, 0.04),
              textAlign: 'center'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Space direction='vertical' size={16}>
              <Text strong style={{ fontSize: '15px' }}>
                Address Preference
              </Text>
              <Space size={16} align='center'>
                <Text>Use Main Member's Address?</Text>
                <Switch
                  checked={dependantSameAddress}
                  checkedChildren='Yes'
                  unCheckedChildren='No'
                  size='default'
                  onChange={(boolean) => {
                    setDependantSameAddress(boolean)
                  }}
                />
              </Space>
            </Space>
          </Card>
        )}

        {/* Address Field */}
        <Form.Item
          label={
            <Text strong style={{ fontSize: '15px' }}>
              Residential Address
            </Text>
          }
          name='residentialAddress'
        >
          <div style={{ position: 'relative' }}>
            <GoogleAddress
              selectProps={{
                size: 'large',
                style: { borderRadius: '8px' },
                placeholder: form.getFieldValue('residentialAddress')
                  ? form.getFieldValue('residentialAddress')
                  : 'e.g. 5 Doe Street, Gqeberha, South Africa',
                onChange: (e) => {
                  form.setFieldValue('residentialAddress', e.label)
                }
              }}
            />
            <div
              style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                zIndex: 1
              }}
            >
              <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: token.colorTextSecondary, fontSize: '14px' }} />
            </div>
          </div>
        </Form.Item>
      </Space>
    </SectionWithBorder>
  )
}

export default AddressDetailsForm
